export default {
  'switch.form.case': 'Case',
  'switch.form.addCase': 'Add case',
  'switch.form.noCases': 'No cases yet. Add at least one.',
  'switch.form.enabled': 'Enabled',
  'switch.form.disabled': 'Disabled',
  'switch.form.nextAction': 'Next action',
  'switch.form.addGroup': 'Add group',
  'switch.form.addCondition': 'Add condition',
  'switch.form.noGroups': 'No condition groups yet. Add at least one.',
  'switch.form.valueSource': 'Value source',
  'switch.form.sourceForm': 'Form',
  'switch.form.sourceField': 'Field',
  'switch.form.sourceVariable': 'Variable',
  'switch.form.sourceIterationTableFieldChild': 'Table field (iteration)',
  'switch.form.sourceIterationDynamicEntityFieldChild': 'Dynamic entity field (iteration)',
  'switch.form.comparisonOperator': 'Operator',
  'switch.form.value': 'Value',
  'switch.form.select.formField': 'Form field',
  'switch.form.select.variable': 'Variable',
  'switch.form.select.iterationStepData': 'Iteration step data',
  'switch.form.select.Equal': 'Equal',
  'switch.form.select.NotEqual': 'Not equal',
  'switch.form.select.GreaterThan': 'Greater than',
  'switch.form.select.GreaterThanOrEqual': 'Greater than or equal',
  'switch.form.select.LessThan': 'Less than',
  'switch.form.select.LessThanOrEqual': 'Less than or equal',
  'switch.form.select.Contains': 'Contains',
  'switch.form.select.NotContains': 'Not contains',
  'switch.form.select.IsNull': 'Is null',
  'switch.form.select.IsNotNull': 'Is not null',
  'switch.validation.missingNextAction': 'Case {order} is enabled but has no next action.',
  'switch.validation.missingConditions': 'Case {order} is enabled but has no conditions.',
};
